import { render } from "./ProductDetailsBox.vue?vue&type=template&id=92781d3c&scoped=true"
import script from "./ProductDetailsBox.vue?vue&type=script&lang=js"
export * from "./ProductDetailsBox.vue?vue&type=script&lang=js"

import "./ProductDetailsBox.vue?vue&type=style&index=0&id=92781d3c&scoped=true&lang=css"

import exportComponent from "D:\\gltech\\NewGrowthWebV2\\code\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-92781d3c"]])

export default __exports__